import React, { useEffect, useMemo, useState } from 'react';
import { useHistory } from 'react-router-dom';

import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Tooltip } from '@mui/material';
import { GOVERNED_WRITERS } from 'utils/Constants';
 
import { UserSessionSelector } from 'store/UserSession';
import { writerOrderDisplaySelector } from 'store/Writer/OrderDisplay';

import {
  setOrderId,
  setOrderContentType,
  setOrderSiloName,
  setTextType as writerSetTextType,
  clearTextState,
  updateForm,
  setOrderWebsite as writerSetOrderWebsite,
} from 'store/Writer/Analyser';
import { fetchWriterText } from 'store/Writer/Analyser/features';

 

import { PAGENUMBERSTINYLIMIT } from 'utils/Constants';

import { ROLES } from 'utils/Constants';

import {
  DownloadOneTextWordType,
  DownloadTextsListWordType,
} from 'components/shared/DownloadFile/DownloadTextWordType';
import ErrorComponent from 'components/shared/ErrorComponent';
import { Loader } from 'components/shared/Loader';
import PageNbOptions from 'components/shared/PageNbOptions';
import SearchComponent from 'components/shared/SearchBar/SearchComponent';
import ErrorSuccesModal from 'components/shared/modal/ErrorSuccesModal';
import { GenerateBillModal } from 'components/shared/modal/GenerateBill/GenerateBillModal';
import RedactionModal from '../modal/RedactionModal';

import DownloadModal from 'components/shared/modal/DownloadModal';

import CardTextIcon from 'icons/CardTextIcon';
import TranslateIcon from 'icons/TranslateIcon';
import { filterTextByStatus, filterTextByType } from 'utils/Constants';

import { getTextColor } from 'helpers/TextColorHelper';
import { textFilterByStatus } from 'helpers/FilterOrders';

import { useTextFilter } from 'utils/hooks/useTextFilter';
import { useHistoryState } from 'utils/hooks/useHistoryState';
import { useTextManagement } from 'utils/hooks/useTextManagement';

import CustomFilterMenu from '../Filter/CustomFilterMenu';
import OrderTextProgress from './OrderTextProgress';

import axiosFacturation from 'config/axiosFacturation';

export const OrderTextsDetailsList = (props) => {
  const { user } = useSelector(UserSessionSelector);
  const { t } = useTranslation();

  const { order, textList, isTextLoading, isTextError } = useSelector(
    writerOrderDisplaySelector
  );

  const dispatch = useDispatch();
  const history = useHistory();

  const [selectedStatus, setSelectedStatus] = useHistoryState(
    'selectedFilter',
    filterTextByStatus[0]
  );
  const [selectedType, setSelectedType] = useState(filterTextByType[0]);

  const [searchValue, setSearchValue] = useState('');

  const [currentPage, setCurrentPage] = useState(1);
  const [textsPerPage, setTextsPerPage] = useState(10);

  const [isTranslate, setIsTranslate] = useState(false);
  const [isText, setIsText] = useState(false);
  const [isCombo, setIsCombo] = useState(false);

  const [errorSuccess, setErrorSuccess] = useState(false);
  const [errorSuccessMsg, setErrorSuccessMsg] = useState('');
  const [isSuccess, setIsSuccess] = useState(false);
  const [isInfo, setIsInfo] = useState(false);
  const [errorSuccessImg, setErrorSuccessImg] = useState(undefined);

  const [factureOpen, setFactureOpen] = useState(false);
  const [isBillGenerated, setIsBillGenerated] = useState(false);
  const [showDownloadModal, setShowDownloadModel] = useState(false);
  const [showRedactionModal, setShowRedactionModal] = useState(false);

  const { currentTexts, sortedTexts, pageNumbers } = useTextManagement(
    user.role,
    textList,
    selectedStatus,
    selectedType,
    searchValue,
    textsPerPage,
    currentPage
  );

  const { isTranslateOnly, isTextOnly, isCombined, isAllTextesDelivered } =
    useTextFilter(sortedTexts);

  const filterTextByStatusArr = filterTextByStatus;
  const remainingTextAmount = order?.textAmount - textList.length;

  const handleSearchValueChange = (newValue) => {
    setSearchValue(newValue);
  };

  useEffect(() => {
    if (user?.role !== ROLES.WRITER) return;
    CheckIfBillGenerated();
  }, [order.id, user]);

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const getPath = (
    user,
    role,
    orderId,
    contentType,
    nomSilo,
    textId,
    texteType
  ) => {
    if (!user) return;
    switch (role) {
      case ROLES.WRITER:
        dispatch(clearTextState());
        dispatch(setOrderId(orderId));
        dispatch(fetchWriterText(textId));
        dispatch(setOrderId(orderId));
        dispatch(writerSetTextType(texteType));
        dispatch(setOrderSiloName(nomSilo));
        dispatch(setOrderContentType(contentType));
        dispatch(writerSetOrderWebsite(order.website.urlSite));
        history.push('/Redacteur/TextDetails');
        break;

      default:
        break;
    }
  };

  const CheckIfBillGenerated = async () => {
    const response = await axiosFacturation.get(
      `/writer/checkIfExist?writerId=${user.id}&commandId=${order.id}`
    );
    setIsBillGenerated(response.data);
  };

  if (isTextLoading) return <Loader />;

  if (isTextError) return <ErrorComponent />;

  return (
    <div>
      <div
        className="box-wrapper"
        style={{ height: '480px' }}
      >
        <OrderTextProgress
          orderTextAmount={props.orderTextAmount}
          textList={textList}
          t={t}
        />

        <div className="box-list-n">
          <div className="col-md-1">
            <CustomFilterMenu
              selectedStatus={selectedStatus}
              handleClick={handleClick}
              anchorEl={anchorEl}
              open={open}
              handleClose={handleClose}
              isTranslateOnly={isTranslateOnly}
              isTextOnly={isTextOnly}
              isCombined={isCombined}
              t={t}
              isText={isText}
              isTranslate={isTranslate}
              isCombo={isCombo}
              setIsTranslate={setIsTranslate}
              setIsText={setIsText}
              setIsCombo={setIsCombo}
              setSelectedStatus={setSelectedStatus}
              filterTextByStatusArr={filterTextByStatusArr}
              filterTextByType={filterTextByType}
              setSelectedType={setSelectedType}
              flag={false}
            />
          </div>
          <div className="col-md-9">
            {' '}
            <SearchComponent
              placeholder={t('Rechercher')}
              searchValue={searchValue}
              onSearchValueChange={handleSearchValueChange}
            />
          </div>

          <div className="col-md-1">
            {sortedTexts.filter((text) => text.delivered).length === 0 ? (
              <span className=" bt-download-circle float-end disabled"></span>
            ) : (
              <span
                className="  bt-download-circle float-end"
                onClick={() =>
                  DownloadTextsListWordType(
                    sortedTexts.filter((text) => text.delivered),
                    user,
                    setShowDownloadModel
                  )
                }
              ></span>
            )}
          </div>
        </div>

        <div className="box-wrap-sm">
          <div className="box-list-li">
            {currentTexts.map((text, idx) => {
              return (
                <div key={text.index} className="box-list-n">
                  <div className="col-md-1"></div>

                  <div
                    className="col-md-8"
                    onClick={() =>
                      getPath(
                        user,
                        user.role,
                        order.id,
                        order.contentType,
                        order.nomSilo,
                        text.id,
                        text.type
                      )
                    }
                    style={{ cursor: 'pointer' }}
                  >
                    <span className={`${getTextColor(text)}`}>
                      {(currentPage - 1) * textsPerPage + idx + 1}.{' '}
                      {text.type === 'NON_TRANSLATED' ||
                      text.type === 'COMBINED' ? (
                        <CardTextIcon />
                      ) : null}
                      {text.type === 'COMBINED' ? ' + ' : ''}
                      {(text.type === 'TRANSLATED' ||
                      text.type === 'COMBINED') && 
                      (order.textType === 'TRANSLATION' || order.textType === 'EDITORIAL_AND_TRANSLATION') ? (
                        <TranslateIcon />
                      ) : null}
                      {'  '}
                      {text.keyword}
                    </span>
                  </div>

                  <div className="col-md-1">
                    <span
                      className="bt-download-circle"
                      onClick={() => DownloadOneTextWordType(text.id, user)}
                    />
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>

      {/** buttons logic */}

      <div className="d-flex justify-content-between">
        <div className="d-flex" style={{ justifyContent: 'space-between' }}>
          {props.orderType !== 'SMART' && (
            <>
              <div>
                {(order.textType !== 'EDITORIAL' &&
                  order.textType !== 'EDITORIAL_AND_TRANSLATION') ||
                (user && user.role !== ROLES.WRITER) ? null : textList.length >=
                  props.orderTextAmount ? (
                  <div className="bt-submit-disabled-y me-1">
                    {' '}
                    {t('Rédaction')}
                  </div>
                ) : (
                  <div
                    className="bt-submit-y me-1"
                    onClick={() => {
                      dispatch(setOrderId(order.id));
                      dispatch(updateForm(null));
                      dispatch(setOrderSiloName(order.nomSilo));
                      dispatch(setOrderContentType(order.contentType));
                      dispatch(writerSetTextType('NON_TRANSLATED'));
                      dispatch(writerSetOrderWebsite(order.website.urlSite));

                      setShowRedactionModal(true);

                      // history.push('/Redacteur/TextDetails');
                    }}
                  >
                    {' '}
                    {t('Rédaction')}
                  </div>
                )}
              </div>
              <div>
                {(order.textType !== 'TRANSLATION' &&
                  order.textType !== 'EDITORIAL_AND_TRANSLATION') ||
                (user && user.role !== ROLES.WRITER) ? null : textList.length >=
                  props.orderTextAmount ? (
                  <div className="bt-submit-disabled-y me-1">
                    {' '}
                    {t('Traduction')}
                  </div>
                ) : (
                  <div
                    className="bt-submit-y me-1"
                    onClick={() => {
                      dispatch(setOrderId(order.id));
                      dispatch(updateForm(null));
                      dispatch(writerSetTextType('TRANSLATED'));
                      dispatch(setOrderSiloName(order.nomSilo));
                      dispatch(setOrderContentType(order.contentType));
                      dispatch(writerSetOrderWebsite(order.website.urlSite));

                      history.push('/Redacteur/TextDetails');
                    }}
                  >
                    {' '}
                    {t('Traduction')}{' '}
                  </div>
                )}
              </div>
              <div>
                {order.textType !== 'EDITORIAL_AND_TRANSLATION' ||
                (user && user.role !== ROLES.WRITER) ? null : textList.length >=
                  props.orderTextAmount ? (
                  <div className="bt-submit-disabled-y me-1">
                    {' '}
                    {t('Rédaction')} + {t('Traduction')}
                  </div>
                ) : (
                  <div
                    className="bt-submit-y me-1"
                    onClick={() => {
                      dispatch(setOrderId(order.id));
                      dispatch(updateForm(null));
                      dispatch(writerSetTextType('COMBINED'));
                      dispatch(setOrderSiloName(order.nomSilo));
                      dispatch(setOrderContentType(order.contentType));
                      dispatch(writerSetOrderWebsite(order.website.urlSite));

                      history.push('/Redacteur/TextDetails');
                    }}
                  >
                    {' '}
                    {t('Rédaction')} + {t('Traduction')}{' '}
                  </div>
                )}
              </div>
              {user?.role === ROLES.WRITER &&
                isAllTextesDelivered(sortedTexts) &&
                remainingTextAmount === 0 && (
                  <>
                    <button
                      className={
                        !isBillGenerated
                          ? 'bt-submit-y me-1'
                          : 'bt-submit-disabled-y me-1'
                      }
                      onClick={() => {
                        setFactureOpen(true);
                      }}
                      disabled={isBillGenerated}
                    >
                      {t('Générer une facture')}
                    </button>
                    <GenerateBillModal
                      isOpen={factureOpen}
                      commandID={order.id}
                      handleClose={() => setFactureOpen(false)}
                      visualize={false}
                    />
                  </>
                )}
            </>
          )}
        </div>

        <div className="d-flex box-pagination">
          <div className="list-page-number me-3 ">
            {pageNumbers
              .slice(
                Math.max(0, currentPage - PAGENUMBERSTINYLIMIT),
                Math.min(currentPage + PAGENUMBERSTINYLIMIT, pageNumbers.length)
              )
              .map((pageNum, index) => (
                <span
                  key={index}
                  className={pageNum === currentPage ? 'active' : ''}
                  onClick={() => setCurrentPage(pageNum)}
                >
                  {pageNum}
                </span>
              ))}
          </div>
          <PageNbOptions
            elementsPerPage={textsPerPage}
            setElementsPerPage={setTextsPerPage}
          />
        </div>
      </div>
      <ErrorSuccesModal
        open={errorSuccess}
        message={errorSuccessMsg}
        imageUrl={errorSuccessImg}
        handleClose={() => setErrorSuccess(false)}
        success={isSuccess}
        info={isInfo}
        toggle={() => setErrorSuccess(!errorSuccess)}
      />

      <DownloadModal
        open={showDownloadModal}
        handleClose={() => setShowDownloadModel(false)}
      />

      <RedactionModal
        isOpen={showRedactionModal}
        onClose={() => setShowRedactionModal(false)}
        orderId={order.id}
        orderSiloName={order.nomSilo}
        orderWebsite={order.website.urlSite}
        language={order.language.language}
        maxWords={order.maxWords}
        orderTextType={order.textType}
        t={t}
      />
    </div>
  );
};
